var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9998 20.8H4.7998V40C4.7998 41.7673 6.23249 43.2 7.9998 43.2H39.9998C41.7671 43.2 43.1998 41.7673 43.1998 40V20.8H39.9998M7.9998 20.8L23.9998 30.4L39.9998 20.8M7.9998 20.8V11.2C7.9998 7.66536 10.8652 4.79999 14.3998 4.79999H33.5998C37.1344 4.79999 39.9998 7.66537 39.9998 11.2V20.8",
    stroke: "#00123A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.4L22.8 18.2L27 14",
    stroke: "#00123A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailVerify);
export default __webpack_public_path__ + "static/media/MailVerify.d518f013fd9eb7decace8ceb12c45124.svg";
export { ForwardRef as ReactComponent };